import React from "react";
import classNames from "../../classNames";
import camelToTitleCase from "../../camelToTitleCase";
import { formatFieldValue } from "./utils";
import PreviewFormModalEmptyState from "./PreviewFormModalEmptyState";
import PreviewFormModalRow from "./PreviewFormModalRow";

export default function PreviewFormModalBody({
  visibleKeys,
  data,
  original,
  schemaFields,
  changedKeysSet,
  schemas,
  progress,
  isEditing,
}) {
  const isEmpty = visibleKeys.length === 0;

  console.log("visibleKeys", visibleKeys);

  return (
    <div
      className={classNames(
        "flex-grow-1 overflow-auto px-4 py-3",
        progress && "opacity-75 pointer-events-none",
      )}
      style={{ maxHeight: "min(60vh, 420px)" }}
      aria-labelledby="preview-modal-title"
      aria-describedby="preview-modal-desc"
    >
      {isEmpty ? (
        <PreviewFormModalEmptyState />
      ) : (
        <>
          <p className="small text-muted mb-2 d-flex align-items-center gap-1">
            <i className="bi bi-check2-square" aria-hidden />
            Details to review
          </p>
          <div
            className="d-flex flex-column rounded-2 overflow-hidden border"
            role="region"
            aria-label="Preview form details"
          >
            {visibleKeys.map((key, index) => {
              const value = data[key];
              const oldValue = original[key];
              const config = schemaFields[key];
              const displayNew = formatFieldValue(value, config, schemas);
              const displayOld = formatFieldValue(oldValue, config, schemas);
              const changed =
                changedKeysSet.has(key) || (key in original && !(key in data));
              const isEmptyValue = displayNew === "-" && !changed;

              if (!value) {
                return "";
              }

              return (
                <PreviewFormModalRow
                  key={key}
                  label={camelToTitleCase(config?.label || key)}
                  displayNew={displayNew}
                  displayOld={displayOld}
                  changed={changed}
                  isEmpty={isEmptyValue}
                  isLast={index === visibleKeys.length - 1}
                  index={index}
                  isEditing={isEditing}
                />
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
